import { settingsRoutes } from '@/routes/org-routes.const'

export type ProfileViewType = 'general'

export const PROFILE_VIEW_TO_URL_PATH: Record<ProfileViewType, string> = {
  general: settingsRoutes.general,
}

export const PROFILE_URL_PATH_TO_VIEW: Record<string, ProfileViewType> = {
  [settingsRoutes.general]: 'general',
}

export const PROFILE_DEFAULT_VIEW: ProfileViewType = 'general'

export const PROFILE_VIEW_TITLES: Record<ProfileViewType, string> = {
  general: 'General',
}

export const PROFILE_VIEW_DESCRIPTIONS: Record<ProfileViewType, string> = {
  general: 'Manage your personal profile settings.',
}
